import { TUIModel } from './../../UIBuilder/ui.d';
import { TClassProject, TransferModelOwnerPayload, TUpsertISRProjectDataModelsInput1 } from './../model.d';
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import AuthManager from "Common/AuthManager";
import { TPaginationParams } from 'Pages/GMS/Performance/analytics';
import { toast } from "react-toastify";

const CREATE_ISR_END_POINT = 'isr/upsert_data_models';
const CREATE_GUIDE_END_POINT = 'guide/upsert_data_models';
const CREATE_UI_MODEL_END_POINT = 'isr/define_ui';
const FETCH_PRODUCTS_END_POINT = "isr/products";
const PROMOTION_END_POINT: string = 'isr/manage_delta_states';
const BASE_URL = AppSettings.GMS_BACKEND_API_URL;

export const createProject = async (payload: TUpsertISRProjectDataModelsInput1, isGuide: boolean) => {
    try {
        const endPoint = isGuide ? CREATE_GUIDE_END_POINT : CREATE_ISR_END_POINT;
        const response = await ServiceWrapper.doPost(
            BASE_URL + endPoint,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const createUIMOdel = async (payload: TUIModel) => {
    try {
        const response = await ServiceWrapper.doPost(
            BASE_URL + CREATE_UI_MODEL_END_POINT,
            payload,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const getUIModels = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/ui_definitions/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProjects = async (isGuide: boolean, industryId: string, channelId: string, paginationParams: TPaginationParams) => {
    try {
        const endPoint = isGuide ? `/guide/projects/${industryId}/${channelId}?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}` : `isr/projects/${industryId}/${channelId}?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}`;
        const response = await ServiceWrapper.doGet(
            BASE_URL + endPoint,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProjectsForAnalytics = async (industryId: string, channelId: string) => {
    try {
        const endPoint = `analytics/isr/projects/${industryId}/${channelId}`;
        const response = await ServiceWrapper.doGet(
            BASE_URL + endPoint,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getISRProject = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/project/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getCategoryTypeAndCategory = async (industryId: string,) => {
    let response = await ServiceWrapper.doGet(
        `${BASE_URL}industry/${industryId}/categorytype/category`,
        null,
        null,
        AuthManager.getGmsToken()
    );

    try {
        return response?.data;
    } catch (e) {
        console.log('Error', e);
        return null;
    }
}

export const getCategoryBasedProducts = async (categoryId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `${FETCH_PRODUCTS_END_POINT}/${categoryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAttributeBasedProducts = async (attributeId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `${FETCH_PRODUCTS_END_POINT}/${attributeId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAssociatedAttributes = async (categoryId: string) => {

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/attributes/${categoryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}


export const getAllAttributes = async (industryId: string) => {

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/${industryId}/attributes`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getAttributeValues = async (attributeId: string) => {
    const limit = 100000; // Set your desired limit
    const skip = 0;      // Set your desired skip value

    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/attribute/${attributeId}/attributevalues/list?limit=${limit}&skip=${skip}`,
        null,
        null,
        AuthManager.getGmsToken()
    );

    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}


export const promoteISR = async (productId: string, uiModelIds: string[]) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + PROMOTION_END_POINT,
        {
            "project_id": productId ?? '',
            "action": "publish",
            "uimodel_ids": uiModelIds
        },
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const deleteISR = async (projectId: string) => {
    const response = await ServiceWrapper.doDelete(
        BASE_URL + `isr/delete_project/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const promoteProductData = async (industryId: string, categories: []) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/sync_isr_delta_data`,
        { industry: industryId, category_ids: categories },
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, 'error');
        return null;
    }
}

export const createClass = async (payload: TClassProject) => {
    const response = await ServiceWrapper.doPost(
        BASE_URL + '/isr/create_class',
        payload,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        return null;
    }
}

export const checkJobStatus = async (jobId: String, previousToastId: any) => {
    try {
        const statusResponse = await ServiceWrapper.doGet(`${BASE_URL}job/status/${jobId}`, null, null, AuthManager.getGmsToken());

        if (!statusResponse.errorfound) {
            const { data } = statusResponse;

            if (data?.error) {
                toast.update(previousToastId, { render: data.status, type: "error", isLoading: false });
                return;
            }

            if (data?.processing) {
                toast.update(previousToastId, { render: 'SB3 Promotion in progress ...', isLoading: true });
                setTimeout(() => { checkJobStatus(jobId, previousToastId); }, 2000);
                return;
            }
            toast.update(previousToastId, { render: 'SB3 Promotion completed', type: "success", isLoading: false, autoClose: 2000 });
        }
    } catch (error) {
        console.error("Error occurred while checking job status:", error);
    }
};

export const getAllProjectClass = async (projectId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/classes/${projectId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const deleteClass = async (projectId: string, classId: string) => {
    const response = await ServiceWrapper.doDelete(
        BASE_URL + `isr/delete_class/${projectId}/${classId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

// isr/update_class
export const updateClass = async (payload: TClassProject) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/update_class`,
        payload,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, 'error');
        return null;
    }
}

export const getIndustryCategoriesData = async (industryId: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/categories/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const getMerchantConfigData = async (channelKey: string) => {
    const response = await ServiceWrapper.doGet(
        BASE_URL + `isr/merchant/config/${channelKey}`,
        null,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const updateMerchantConfigData = async (channelKey: string, merchantConfigData: { config_attr: any; value: any }[]) => {
    const response = await ServiceWrapper.doPut(
        BASE_URL + `isr/merchant/config/${channelKey}`,
        merchantConfigData,
        null,
        AuthManager.getGmsToken()
    );
    try {
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}
export const transferModelOwner = async (data: TransferModelOwnerPayload) => {
    try {
        const res = await ServiceWrapper.doPut(
            `${BASE_URL}isr/transfer_ownership`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        if (res?.data?.done)
            return res;
    } catch (error) {
        return null
    }
};

export const copyModel = async (modelId: string) => {
    try {
        const res = await ServiceWrapper.doPost(
            `${BASE_URL}guide/clone_model/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        if (res?.data?.done)
            return res;
    } catch (error) {
        return null
    }
};

export const getRecommenderModelsForGuide = async (channelKey: string, base_categories?: string[], target_categories?: string[]) => {
    try {
        const params = new URLSearchParams({});
        if (base_categories && base_categories.length > 0) params.append('base_categories', JSON.stringify(base_categories));
        if (target_categories && target_categories.length > 0) params.append('target_categories', JSON.stringify(target_categories));

        const endpoint = `${BASE_URL}guide/channel/${channelKey}/recommender_model?${params.toString()}`;
        let res = await ServiceWrapper.doGet(
            endpoint,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (!res.errorfound) {
            return res.data;
        } else return null;
    } catch (error) {
        console.error("Error fetching recommender model data:", error);
        return null;
    }
};

export const uploadProductModel = async (file: File, channelKey: string) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await ServiceWrapper.doPost(
            `${BASE_URL}override-mappings/upload/${channelKey}`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (e) {
        return null;
    }
};
